import { getCouponCode } from '../helpers';
import { HEADERS, simpleFetch, simpleFetchWithHttp } from './customFetch';

export const updateSubscription = (plan, currentPlan, couponsApplied = [], captchaToken) => {
  const couponCode = getCouponCode(couponsApplied);
  const headers = {
    ...HEADERS,
    'hcaptcha-token': captchaToken,
  };
  return simpleFetchWithHttp(
    '/api/2/upgrade',
    {
      method: 'POST',
      body: JSON.stringify({
        target_plan_code: plan,
        current_plan_code: currentPlan,
        coupon_code: couponCode,
      }),
      headers,
    },
    process.env.REACT_APP_REGISTRATION_API,
  );
};

export const reactivateExpiredSubscription = (plan, promoCode, captchaToken, promoCodeType) => {
  const headers = {
    ...HEADERS,
    'hcaptcha-token': captchaToken,
  };

  const payload = {
    plan_code: plan,
    ...(promoCodeType === 'coupon' && { coupon_code: promoCode }),
    ...(promoCodeType === 'giftcard' && { gift_card: promoCode }),
  };

  return simpleFetchWithHttp(
    '/api/2/reactivate/expired',
    {
      method: 'POST',
      body: JSON.stringify(payload),
      headers,
    },
    process.env.REACT_APP_REGISTRATION_API,
  );
};

export const reactivateCancelledSubscription = () => {
  return simpleFetchWithHttp(
    '/api/1/reactivate/cancelled',
    {
      method: 'POST',
      body: JSON.stringify({
        coupon_code: '',
      }),
    },
    process.env.REACT_APP_REGISTRATION_API,
  );
};

export const getPriceLock = (status) => {
  const url = status ? `/api/1/price/lock?status=${status}` : '/api/1/price/lock';
  return simpleFetch(
    url,
    {
      method: 'GET',
    },
    process.env.REACT_APP_GROWTH_API,
  );
};

export const postPriceLock = () =>
  simpleFetchWithHttp(
    '/api/1/price/lock',
    {
      method: 'POST',
    },
    process.env.REACT_APP_GROWTH_API,
  );
